import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { PipesModule } from '@commons/pipes/pipes.module';
import { RouteSummaryStats } from '@src/app/interfaces/route-stats.interface';

@Component({
  selector: 'app-summary-route',
  standalone: true,
  imports: [PipesModule, TranslateModule, CommonModule],
  templateUrl: './summary-route.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./summary-route.component.scss'],
})
export class SummaryRouteComponent {
  @Input() public data: RouteSummaryStats & { stopTime: string };
}
